import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as WordSearchService from 'services/agents/content/word-search';

export const useWordSearchService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchWordSearches = async (options = {}) => {
    const { error, payload } = await WordSearchService.read({ ...options, token });

    if (error) {
      toast.error(error);
      return { word_searches: [], size: 0 };
    }

    const {
      data: word_searches,
      meta: { size }
    } = payload;
    return { word_searches, size };
  };

  const fetchWordSearch = async (id, options = {}) => {
    const { error, payload: word_search } = await WordSearchService.readById(id, {
      ...options,
      token
    });

    if (error) {
      toast.error(error);
      return { word_search: null };
    }

    return { word_search };
  };

  const searchWordSearches = async (keys, keyword, options = {}) => {
    const { error, payload } = await WordSearchService.search(keys, keyword, {
      ...options,
      token
    });

    if (error) {
      toast.error('Unable to fetch word searches at this time.');
      return { word_searches: [], size: 0 };
    }

    const {
      data: word_searches,
      meta: { size }
    } = payload;
    return { word_searches, size };
  };

  const generateWordSearch = async (data, options = {}) => {
    const { error, payload } = await WordSearchService.generate({ ...options, data, token });

    if (error) {
      toast.error(error || 'Unable to generate word search at this time.');
      return { word_search_id: null };
    }

    toast.success('Word search generation started');
    return { word_search_id: payload?.word_search_id || null };
  };

  const deleteWordSearch = async (id, options = {}) => {
    const { error } = await WordSearchService.deleteOne(id, { ...options, token });

    if (error) {
      toast.error(error || 'Unable to delete word search at this time.');
      return false;
    }

    toast.success('Word search deleted successfully');
    return true;
  };

  return {
    deleteWordSearch,
    fetchWordSearch,
    fetchWordSearches,
    generateWordSearch,
    searchWordSearches
  };
};
